import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { STATUS_TYPE } from '../types';

@Pipe({
  name: 'getStatusText',
})
export class GetStatusTextPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(status?: number): string {
    return this.translateService.instant(STATUS_TYPE.find(type => type.id === status)?.value ?? ' ');
  }
}
